import { ResetPasswordForm } from '@r/components/resetPassword/reset-password-form.tsx';
import { Button } from '@ui/button.tsx';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@ui/card.tsx';
import { ArrowLeft, Send } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

type ResetPasswordData = {
  email: string;
};

const ResetPassword = () => {
  const resetPasswordQuery = useQuery<ResetPasswordData>({
    queryKey: ['reset_password'],
    staleTime: 0,
    enabled: false
  });

  const { t } = useTranslation();

  if (resetPasswordQuery.data) {
    return (
      <div className="container flex flex-col pt-8 grow">
        <Link to="/">
          <Button variant="outline" className="mb-7 sm:mb-0">
            <ArrowLeft className="mr-1" />
            {t('common.back.btn')}
          </Button>
        </Link>

        <div className="flex max-w-[100%] flex-grow items-center sm:w-[32rem]">
          <Card className="w-[32rem] rounded-[30px] p-16">
            <CardHeader className="p-0">
              <div className="flex justify-center text">
                <Send className="w-16 h-auto stroke-accent" />
              </div>

              <CardTitle className="text-center font-author-complete font-regular text-[2.75rem] leading-[3rem]">
                {t('reset.password.email.sent.title')}
              </CardTitle>

              <CardDescription className="text-sm font-light text-center text-muted-foreground">
                {t('reset.password.email.sent.description', {
                  email: resetPasswordQuery.data.email
                })}
              </CardDescription>
            </CardHeader>
            <CardContent className="p-0 mt-12">
              <Link to="/">
                <Button className="w-full">{t('reset.password.email.btn.home')}</Button>
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="container flex flex-col pt-8 grow">
      <Link to="/">
        <Button variant="outline" className="mb-7 sm:mb-0">
          <ArrowLeft className="mr-1" />
          {t('common.back.btn')}
        </Button>
      </Link>

      <div className="flex max-w-[100%] flex-grow items-center sm:w-[32rem]">
        <Card className="w-[32rem] rounded-[30px] p-16">
          <CardHeader className="p-0">
            <CardTitle className="text-center font-author-complete font-regular text-[2.75rem] text-foreground leading-[3rem]">
              {t('forgot.password.title')}
            </CardTitle>

            <CardDescription className="text-sm font-light text-center text-muted-foreground">
              {t('forgot.password.description')}
            </CardDescription>
          </CardHeader>

          <CardContent className="p-0 mt-12">
            <ResetPasswordForm />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ResetPassword;
